import React from "react";
import "./Why_People_Trust_Us.css";

const Why_People_Trust_Us = () => {
  return (
    <section
      class="why-trust-section"
    >
      <div class="overlay">
        <div class="container">
          <div class="section-header text-center">
            <h2> Why Choose Loconex</h2>
            <p>Why People Trust Us</p>
          </div>

          <div class="row justify-content-center">
            <div class="col-lg-10">
              <div class="trust-grid">
                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>One city digital platform</h5>
                </div>

                <div class="trust-card">
                 <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Verified information</h5>
                </div>

                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Hyperlocal discovery</h5>
                </div>

                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Faster access to services</h5>
                </div>

                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Strong support for small businesses</h5>
                </div>

                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Designed for real communities</h5>
                </div>


                {/* ------------------------- */}

                
                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Strong focus on local growth</h5>
                </div>

                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Verified city-wide information</h5>
                </div>

                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Faster access to nearby services</h5>
                </div>

                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Support for farmers and small businesses</h5>
                </div>

                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Trusted emergency and public contacts</h5>
                </div>

                <div class="trust-card">
                  <img src="/assets/images/home/why_people_trust/check.png" className="point_img"/>
                  <h5>Simple, powerful, and easy to use</h5>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_People_Trust_Us;
